import jStat from 'jstat';

export interface MedianAbsoluteDeviationResult {
  population: {
    medianDeviation: number;
  };
  sample: {
    medianDeviation: number;
  };
  median: number;
  data: number[];
  interpretation: string;
}

export function calculateMedianAbsoluteDeviation(data: number[]): MedianAbsoluteDeviationResult {
  const sortedData = [...data].sort((a, b) => a - b);
  const median = jStat.median(data);
  
  // Calculate absolute deviations from median
  const absoluteDeviations = data.map(val => Math.abs(val - median));
  
  // Calculate median of absolute deviations
  const medianAbsoluteDeviation = jStat.median(absoluteDeviations);
  
  // For sample MAD, we adjust by a consistency factor for normal distribution
  const consistencyFactor = 1.4826; // This makes MAD consistent with standard deviation for normal distributions
  const sampleMAD = medianAbsoluteDeviation * consistencyFactor;
  
  return {
    population: {
      medianDeviation: medianAbsoluteDeviation
    },
    sample: {
      medianDeviation: sampleMAD
    },
    median,
    data: sortedData,
    interpretation: `The median absolute deviation from ${median.toFixed(2)} is ${medianAbsoluteDeviation.toFixed(2)} (population) and ${sampleMAD.toFixed(2)} (sample). This is a robust measure of variability that is less sensitive to outliers than mean absolute deviation.`
  };
} 